exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chart-card[data-v-7e8aa4dc] {\r\n    margin-bottom: 20px;\n}\n.card[data-v-7e8aa4dc] {\r\n    background-color: #fff;\r\n    border-radius: 2px;\n}\n.picker[data-v-7e8aa4dc] {\r\n    margin-top: 1em;\n}\r\n", ""]);

// exports
